import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=5a1269f8&"
import script from "./ContactList.vue?vue&type=script&lang=ts&"
export * from "./ContactList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports